"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isUrlAbsolute = void 0;

// Check to see if the url is non-relative (i.e. contains a full path)
var isUrlAbsolute = function isUrlAbsolute(url) {
  var absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');
  return absoluteUrlRegExp.test(url);
};

exports.isUrlAbsolute = isUrlAbsolute;